import React from 'react';
import PropTypes from 'prop-types';

import ClickableWrap from '../ClickableWrap';

// import './styles.less';

const BreadCrumbs = (props) => {
    const crumbsLen = props.nextCrumbs.length;
    return (
        <div>
            <span style={props.onClick ? { cursor: 'pointer' } : null}>
                <ClickableWrap onClick={props.onClick}>{props.headCrumb ? props.headCrumb : null}</ClickableWrap>
            </span>
            {crumbsLen ? props.separator : null}
            {props.nextCrumbs.map((elem, i) => {
                return (
                    <span key={elem.crumb} style={elem.onClick ? { cursor: 'pointer' } : null}>
                        <ClickableWrap
                            onClick={() => {
                                if (elem.onClick) elem.onClick(i);
                            }}
                        >
                            {elem.crumb ? elem.crumb : null}
                        </ClickableWrap>
                        {crumbsLen > i + 1 ? props.separator : null}
                    </span>
                );
            })}
        </div>
    );
};

BreadCrumbs.propTypes = {
    contentId: PropTypes.string,
    headCrumb: PropTypes.element, //Inline element for displaying a the head crumb.
    onClick: PropTypes.func, //Onclick function for the head crumb.
    separator: PropTypes.element, //Inline element for separating this crumb & the next.
    nextCrumbs: PropTypes.array
};

BreadCrumbs.defaultProps = {
    contentId: undefined,
    headCrumb: undefined,
    onClick: undefined,
    separator: <span> {'->'} </span>
};

export default BreadCrumbs;
